export default __webpack_public_path__ + "static/media/rectangle-linked-file-linked-file-linked-file.efc6a936.png";